import conferenceConfig from './conference'

const countdownConfig = {
  // NOTE: this represents the phase, but also includes registration features.
  starts: '2027-01-27T08:00:00-07:00',
  ends: conferenceConfig.starts,
}

export default countdownConfig
